class MessageListener {
  constructor() {
    this.onReceiveMessage = null;
  }
  start(onReceiveMessage) {
    this.onReceiveMessage = onReceiveMessage;
    window.addEventListener('message:action', this.onReceiveMessage, false);
  }
  stop() {
    if (this.onReceiveMessage){
      window.removeEventListener('message:action', this.onReceiveMessage);
    }
  }
}

export default MessageListener = new MessageListener();
